import Typography from '@mui/material/Typography';
import styled from '@emotion/styled';

export const Title = styled(Typography)`
  font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
  font-size: 16px;
  margin-top: ${({ theme }) => theme.spacing(4)};
`;
